import {
  ProjectModel,
  UpdateBidSubmissionDetailsModel,
} from "../models/ProjectModel";
import { BidCreationDocumentModel } from "../models/BidCreationDocumentsModel";
import { CountryModel } from "../models/CountryModel";
import { StateModel } from "../models/StateModel";
import API, { client } from "./API";
import { FileWithPath } from "react-dropzone";
import { stringifyDate } from "../utility/utils";

const ProjectService = {
  async getAllProjects() {
    const response = await API().get("Project", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularProject(Project_id: number) {
    const response = await API().get("Project");
    return response.data.filter(
      (cur_Project: ProjectModel) => cur_Project.projectId === Project_id
    )[0];
  },
  async getProjectByProjectName(Project_name: string) {
    const response = await client({
      url: "Project/GetProjectByProjectName",
      method: "POST",
      data: {
        name: Project_name,
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async postProject(userId: number, projectData: ProjectModel) {
    const { createdBy, ...rest } = projectData;
    try {
      const response = await client({
        url: `Project/${userId}`,
        method: "post",
        data: rest,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async putProject(
    userId: number,
    projectId: number,
    projectData: ProjectModel
  ) {
    const { createdBy, createdDate, modifiedDate, tenderExpectedDate, awardExpectedDate, bidSubmissionDate, ...rest } = projectData;
    const dateObject = {
      createdDate: stringifyDate(createdDate),
      modifiedDate: stringifyDate(modifiedDate),
      tenderExpectedDate: stringifyDate(tenderExpectedDate),
      awardExpectedDate: stringifyDate(awardExpectedDate),
      bidSubmissionDate: bidSubmissionDate && stringifyDate(bidSubmissionDate)
    };
    const response = await client({
      url: `Project/${projectId}/${userId}`,
      method: "put",
      data: {...rest, ...dateObject},
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async checkIfProjectNameExists(projectName: string) {
    const response = await client({
      url: "Project/CheckProjectNameExists",
      data: {
        name: projectName,
      },
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async postProjectDocuments(
    projectId: number,
    bidDocuments: BidCreationDocumentModel[]
  ) {
    const formData = new FormData();
    // formData.append("projectId", projectId.toString());
    bidDocuments.forEach((doc) => {
      formData.append("documents", doc.file);
    });
    try {
      const response = await API().post(
        "ProjectDocument/PostPDByProjectId/" + projectId,
        formData,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectDocument(id: number, type: string) {
    try {
      const response = await API().get(
        `${
          type === "project"
            ? "ProjectDocument"
            : "ProjectDocument/GetWinLossDocument"
        }/${id}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/octet-stream",
          },
        }
      );
      const url = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      //link.setAttribute('download', "example.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  },
  async getAllCountries() {
    const response = await API().get("Project/Countries", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getAllStates() {
    const response = await API().get("Project/States", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getStatesForCountry(countryCode: string) {
    const response = await API().get(
      "Project/Countries/" + countryCode + "/States",
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
  async createCountry(data: CountryModel, id?: string) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Project/Countries/${id}` : "Project/Countries",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteCountry(data: CountryModel) {
    try {
      const response = await client({
        method: "delete",
        url: "Project/Countries",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async createState(data: StateModel, id?: string) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Project/States/${id}` : "Project/States",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteState(data: StateModel) {
    try {
      const response = await client({
        method: "delete",
        url: "Project/States",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getAllAdminProjects() {
    try {
      const response = await client({
        method: "get",
        url: "Project/GetProjectsAdmin",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async postProjectWinLossDocument(id: number, document: FileWithPath) {
    const formData = new FormData();
    formData.append("documents", document);
    try {
      const response = await API().post(
        "ProjectDocument/PostWinLossDocument/" + id,
        formData,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async updateBidExploratoryStatus(id: number, status: boolean) {
    try {
      const response = await API().post(
        `Project/SetBidExploratoryStatus/${id}/${status ? "yes" : "no"}`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async updateEnforceCSGOApproval(id: number, status: boolean) {
    try {
      const response = await API().post(
        `Project/SetEnforceCsgoApproval/${id}/${status ? "yes" : "no"}`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async updateBidSubmissionDetails(
    userId: number,
    id: number,
    data: UpdateBidSubmissionDetailsModel
  ) {
    try {
      const response = await client({
        url: `Project/UpdateProjectValuesAfterSubmission/${id}/${userId}`,
        method: "post",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async setIsBidDropped(id: number, status: boolean) {
    try {
      const response = await client({
        url: `Project/SetIsBidDropped/${id}/${status ? "yes" : "no"}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async setBidPriority(userId: number, id: number, priority: string) {
    try {
      const response = await client({
        url: `Project/SetBidPriority/${id}/${priority}/${userId}`,
        method: "post",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectHistory(projectId: number, type?: string, isAllDataRequired = false) {
    try {
      const response = await client({
        url: `Project/History/${projectId}${type ? "/" + type : "/null"}/${isAllDataRequired}`,
        method: "get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectHistoryData(id: number) {
    try {
      const response = await client({
        url: `Project/GetHistoryData/${id}`,
        method: "get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async fetchUserProjectsReportData(userId: number, roleId: number) {
    try {
      const response = await client({
        url: `Project/GetReportingModuleData/${userId}/${roleId}`,
        method: "get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default ProjectService;
